var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 3a1 1 0 0 1 1-1h4v2H1a1 1 0 0 1-1-1M0 15a1 1 0 0 1 1-1h4v2H1a1 1 0 0 1-1-1M24 9a1 1 0 0 1-1 1h-4V8h4a1 1 0 0 1 1 1M8 2h15a1 1 0 1 1 0 2H8zM8 14h15a1 1 0 1 1 0 2H8zM16 10H1a1 1 0 0 1 0-2h15z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  x: 4,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  x: 4,
  y: 12,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 6,
  x: 17,
  y: 12,
  rx: 1,
  transform: "rotate(-180 17 12)"
})));
export { SvgSettings as ReactComponent };